import { TitreTexteMedia } from '@components/titre-texte-media/models';
import { imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

const createTitreTexteMediaBlock = (data: TitreTexteMedia): Block<TitreTexteMedia> => ({
  type: 'titre-texte-media',
  data,
});

export const titreTexteMediaLpSimple1 = (): Block<TitreTexteMedia> =>
  createTitreTexteMediaBlock({
    title: {
      text: 'Le made in France qui a tout bon',
      as: 'h2',
    },
    text: `<ul><li><strong>Qualité des matériaux et de la fabrication française</strong><p>Tous les matériaux et pièces qui entrent dans la fabrication de nos cuisines sont sélectionnés pour leur <a href="/mock-estimateur-budget">meilleur rapport qualité / prix / fonctionnalité</a>. De plus, nos matières premières proviennent majoritairement de France, ce qui contribue à notre impact environnemental relativement faible.</p></li><li><strong>Des designs tendances</strong><p>Nous restons inventifs et à l'écoute de nos clients. Nos équipes veillent à composer une gamme astucieuse qui répond vraiment à leurs besoins. Voilà pourquoi nous fabriquons un choix ciblée en grand volume pour rendre accessible une cuisine tendance et fonctionnelle mais jamais hors de prix.</p></li></ul>`,
    media: imageMock,
    desktopMediaSide: 'left',
  });

export const titreTexteMediaLpSimple2 = (): Block<TitreTexteMedia> =>
  createTitreTexteMediaBlock({
    title: {
      text: 'La qualité française avant tout.',
      as: 'h2',
    },
    text: `<ul><li><strong>Durabilité et longévité</strong><p>Nous nous imposons de hauts standards de solidité et de durée de vie sur nos <a href="/mock-plans-de-travail">plans de travail</a> et charnières, les éléments les plus sollicités au quotidien, c'est parce qu'on est convaincu qu'une cuisine est de bonne qualité quand on peut en profiter tous les jours.</p></li><li><strong>Engagement éco-responsable de notre marque de cuisine française</strong><p>La fabrication française de nos cuisines ce n'est pas juste une histoire de qualité et de savoir-faire, c'est aussi créer des emplois et soutenir l'économie de nos régions. Notre entreprise est un acteur français majeur, elle emploie plus de 1300 personnes en métropole et outre-mer sur différents sites de production.</p></li></ul>`,
    media: imageMock,
    desktopMediaSide: 'right',
  });

export const titreTexteMediaLpSimple3 = (): Block<TitreTexteMedia> =>
  createTitreTexteMediaBlock({
    title: {
      text: 'Un fabricant de cuisine avec une conception française 100% sur-mesure',
      as: 'h2',
    },
    text: `<p>Chez SoCoo'c, la co-conception est au coeur de notre relation client. Grâce à son expertise et son écoute active, le Kitchener conçoit avec son client la cuisine qui correspond le mieux à son mode de vie et son budget. Ici, pas de place pour le bla-bla, ni la poudre aux yeux ! Chaque client est guidé pas à pas avec bienveillance et en toute transparence vers les meilleurs choix. Et cerise sur le gâteau, le client peut visualiser en live les possibilités d'agencement de sa cuisine, les matériaux qu'il a choisi et voir son budget se construire au fur et à mesure de ses choix grâce à Coo'ki, un outil digital ludique et pédagogique unique sur le marché.</p>`,
    media: imageMock,
    desktopMediaSide: 'left',
  });

export const titreTexteMediaLpSimple4 = (): Block<TitreTexteMedia> =>
  createTitreTexteMediaBlock({
    title: {
      text: "Nos usines de fabrication d'élément et de meuble de cuisine en Haute-Savoie pour une fabrication 100% française",
      as: 'h2',
    },
    text: `<p>Grâce aux investissements conséquents et réguliers du Groupe Fournier, nous bénéficions des équipements industriels parmi les plus performants d'Europe. Ils nous permettent de fabriquer des meubles en grand volume, tout en garantissant une qualité irréprochable. Nos équipes de production hautement qualifiées assurent une excellence industrielle. Nos équipes travaillent ensemble dans une démarche d'amélioration continue avec un seul objectif en tête : assurer la parfaite fabrication française de plus de 200 cuisines chaque jour. Résultat ? Des cuisines alliant tradition française et modernité, avec une précision au millimètre près. Cette quête d'excellence nous pousse à repenser continuellement nos méthodes, pour vous offrir des cuisines toujours plus fonctionnelles et esthétiques. Chez SoCoo'c, l'innovation n'est pas un luxe, c'est notre standard.</p>`,
    media: {
      link: 'https://www.youtube.com/watch?v=PJl8mHP1t1s',
      legend: "SoCoo'c et le Made in France, une histoire qui dure",
    },
    desktopMediaSide: 'right',
  });

export const titreTexteMediaFranchiseHomepage1 = (): Block<TitreTexteMedia> =>
  createTitreTexteMediaBlock({
    title: {
      text: 'On recherche des cuisinistes. Oui, [[mais pas comme les autres.]]',
      as: 'h2',
    },
    text: `<p>Chez SoCoo'c, avant de recruter une compétence, nous cherchons d'abord une personnalité et un savoir-être. Car pour les compétences, il y a l'accompagnement que nous mettons en place auprès de tous nos franchisés.</p>`,
    cta: {
      label: 'En savoir plus',
      url: '/mock-espace-franchise/profils-recherches',
    },
    media: imageMock,
    desktopMediaSide: 'right',
  });

export const titreTexteMediaFranchiseHomepage2 = (): Block<TitreTexteMedia> =>
  createTitreTexteMediaBlock({
    title: {
      text: "SoCoo'c. Vous allez voir, [[ça n'a rien à voir.]]",
      as: 'h2',
    },
    text: `<p>Chez SoCoo'c, nous avons fait le choix de bousculer les codes en dédramatisant et en simplifiant l'achat d'une cuisine. Car nous n'avons qu'un seul objectif : rendre la cuisine de spécialiste accessible à tous !</p>`,
    cta: {
      label: 'En savoir plus',
      url: '/mock-cuisines',
    },
    media: imageMock,
    desktopMediaSide: 'left',
  });

export const titreTexteMediaFranchiseHomepage3 = (): Block<TitreTexteMedia> =>
  createTitreTexteMediaBlock({
    title: {
      text: 'Nous, on aime les chiffres qui comptent.',
      as: 'h2',
    },
    text: '<p>Rentabilité, dynamisme du marché ou investissement de base… Retrouvez tous les chiffres essentiels pour vous lancer en toute transparence.</p>',
    cta: {
      label: 'En savoir plus',
      url: '/mock-espace-franchise',
    },
    media: imageMock,
    desktopMediaSide: 'right',
  });

export const titreTexteMediaFranchiseCuisinistes1 = (): Block<TitreTexteMedia> =>
  createTitreTexteMediaBlock({
    title: {
      text: "Ici, avant d'être cuisiniste, on a l'esprit de famille.",
      as: 'h2',
    },
    text: `<p>Ouvrir son magasin avec SoCoo'c, c'est avant tout signer pour une aventure humaine et rejoindre une grande famille composée de plus de 180 magasins et de toutes les fonctions supports de l'enseigne qui vous accompagne au quotidien.</p><p>Que vous soyez jeune actif ou plus expérimenté, issu du commerce, de la vente ou de tout autre horizon, nous recherchons chaque année de nouveaux franchisés pour nous rejoindre dans l'aventure SoCoo'c.</p>`,
    media: imageMock,
    desktopMediaSide: 'right',
  });

export const titreTexteMediaFranchiseCuisinistes2 = (): Block<TitreTexteMedia> =>
  createTitreTexteMediaBlock({
    title: {
      text: "Le bon profil, c'est d'abord le vôtre.",
      as: 'h2',
    },
    text: `<p>Ouvrir son magasin avec SoCoo'c, c'est avant tout signer pour une aventure humaine et rejoindre une grande famille composée de plus de 180 magasins et de toutes les fonctions supports de l'enseigne qui vous accompagne au quotidien.</p><p>Mais avant tout, nous recherchons des personnes avec une âme de commerçant, venant de tous horizons, pas forcément du monde de la cuisine. Ouvrir un magasin SoCoo'c, c'est s'investir durablement dans une aventure professionnelle humaine et enrichissante.</p>`,
    media: imageMock,
    desktopMediaSide: 'left',
  });

export const titreTexteMediaFranchiseCuisinistes3 = (): Block<TitreTexteMedia> =>
  createTitreTexteMediaBlock({
    title: {
      text: "Vous ne venez pas de l'univers de la cuisine ? Vous avez toutes vos chances !",
      as: 'h2',
    },
    text: `<p>Chez SoCoo'c, nous privilégions les savoir-être et la personnalité de nos candidats.</p><p>80% de nos équipes ne sont pas issues de l'univers de la cuisine. C'est pourquoi nous avons conçu des parcours de formation dédiés pour former et accompagner nos franchisés et leurs équipes dans leur montée en compétence.</p>`,
    media: {
      link: 'https://www.youtube.com/watch?v=PJl8mHP1t1s',
      legend: "SoCoo'c et le Made in France, une histoire qui dure",
    },
    desktopMediaSide: 'right',
  });
